// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"475":"1d447ddf","930":"e3b56b4a"}[chunkId] + ".chunk.css";
};